import toastTemplate from './template/toast.html';
import toastMessageTemplate from './template/toast-message.html';

run.$inject = ['$templateCache'];

export default function run($templateCache) {
    $templateCache.put('ngToast/toast.html', toastTemplate);
    $templateCache.put('ngToast/toastMessage.html', toastMessageTemplate);
}
